<!-- src/components/ui/AtlasSpacer.vue -->
<template>
  <v-spacer v-bind="$attrs" />
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>
